import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ams_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !String(err.config?.url).includes("/admin/login")) {
      localStorage.removeItem("ams_admin_token");
      if (!window.location.pathname.startsWith("/admin/login")) window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) return d.map((x) => x.msg?.replace("Value error, ", "")).join(" · ");
  return fallback;
};

export const waLink = (number, text) => {
  const digits = String(number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${digits}?text=${encodeURIComponent(text || "")}`;
};

export const tr = (tour, lang) => {
  const t = tour?.translations || {};
  const base = t.en || {};
  const cur = t[lang] || {};
  const pick = (k) => {
    const v = cur[k];
    if (Array.isArray(v)) return v.length ? v : base[k] || [];
    return v || base[k] || "";
  };
  return {
    title: pick("title"),
    short: pick("short"),
    description: pick("description"),
    itinerary: pick("itinerary"),
    included: pick("included"),
    not_included: pick("not_included"),
    good_to_know: pick("good_to_know"),
    faqs: pick("faqs"),
  };
};

export const euro = (n) => `€${Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 0 })}`;
